import React from 'react';

export const ChevronRightIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="#292E2E" fillRule="evenodd"/>
  </svg>
);
